(function () {
  'use strict';

  var renderSequence = 0;

  function isAr(el) {
    if (window.MMOffers && window.MMOffers.isAr) return window.MMOffers.isAr(el);
    if (el && el.getAttribute) {
      var dl = el.getAttribute('data-lang');
      if (dl) return dl.toLowerCase().indexOf('ar') === 0;
    }
    var loc = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
    return loc.toLowerCase().indexOf('ar') === 0;
  }

  function t(ar, en, el) {
    return isAr(el) ? ar : en;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function sizedImageUrl(src, width) {
    if (!src) return '';
    try {
      var value = String(src);
      if (value.indexOf('//') === 0) value = window.location.protocol + value;
      var url = new URL(value, window.location.origin);
      if (!/(^|\.)cdn\.shopify\.com$|(^|\.)shopifycdn\.net$/i.test(url.hostname)) return value;
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return String(src);
    }
  }

  function responsiveImage(src, title, className, sizes) {
    if (!src) return '';
    return '<img src="' + esc(sizedImageUrl(src, 440)) + '"' +
      ' srcset="' + esc(sizedImageUrl(src, 220)) + ' 220w, ' +
      esc(sizedImageUrl(src, 330)) + ' 330w, ' + esc(sizedImageUrl(src, 440)) + ' 440w"' +
      ' sizes="' + esc(sizes) + '" alt="' + esc(title) + '" loading="lazy" decoding="async"' +
      ' width="440" height="440"' + (className ? ' class="' + esc(className) + '"' : '') + '>';
  }

  function jp(raw, fallback) {
    if (window.MMOffers && window.MMOffers.jp) return window.MMOffers.jp(raw, fallback);
    if (raw == null) return fallback || [];
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'object') return raw;
    try { return JSON.parse(raw || fallback || '[]'); } catch (e) { return fallback || []; }
  }

  function configItems(raw) {
    if (window.MMOffers && window.MMOffers.configItems) return window.MMOffers.configItems(raw);
    var v = jp(raw, []);
    if (Array.isArray(v)) return v;
    if (v && typeof v === 'object') {
      var out = [];
      if (v.trigger) out.push(v.trigger);
      if (v.target) out.push(v.target);
      return out;
    }
    return [];
  }

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root.slice(0, -1) : root;
  }

  function moneyDiv(el) {
    var d = parseInt(el.getAttribute('data-money-divisor'), 10);
    if (d === 100 || d === 1000) return d;
    var htmlDiv = parseInt(document.documentElement.getAttribute('data-mm-money-divisor'), 10);
    if (htmlDiv === 100 || htmlDiv === 1000) return htmlDiv;
    return 1000;
  }

  function fmtPrice(minor, el) {
    minor = parseInt(minor, 10) || 0;
    var div = moneyDiv(el);

    if (window.mmCurrencyConfig && typeof window.mmCurrencyConfig.formatWithTax === 'function') {
      return window.mmCurrencyConfig.formatWithTax(minor, div);
    }
    if (window.mmTaxConfig && typeof window.mmTaxConfig.formatWithTax === 'function') {
      return window.mmTaxConfig.formatWithTax(minor);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(minor, window.Shopify.money_format || '${{amount}}');
    }
    return (minor / div).toFixed(3);
  }

  function priceSpan(minor, el) {
    minor = parseInt(minor, 10) || 0;
    return '<span class="mm-taxed-price" data-original-price="' + minor + '" data-mm-divisor="' + moneyDiv(el) + '">' +
      esc(fmtPrice(minor, el)) + '</span>';
  }

  function bogoBadgeCarousel(el) {
    if (isAr(el)) {
      return '<span class="mm-bogo-badge mm-bogo-badge--carousel mmh-carousel-card__tag mmh-carousel-card__tag--bogo">' +
        '<span class="mm-bogo-badge__pct">50% خصم</span>' +
        '<span class="mm-bogo-badge__text">اشتري 1 والثاني مجاناً</span></span>';
    }
    return '<span class="mm-bogo-badge mm-bogo-badge--carousel mmh-carousel-card__tag mmh-carousel-card__tag--bogo">' +
      '<span class="mm-bogo-badge__pct">50% OFF</span>' +
      '<span class="mm-bogo-badge__text">Buy 1, Get 1 Free</span></span>';
  }

  function bogoBadgeGrid(el) {
    if (isAr(el)) {
      return '<div class="mm-offer-card-badge mm-offer-card-badge--bogo mm-bogo-badge mm-bogo-badge--card">' +
        '<span class="mm-bogo-badge__pct">50% خصم</span>' +
        '<span class="mm-bogo-badge__text">اشتري 1 والثاني مجاناً</span></div>';
    }
    return '<div class="mm-offer-card-badge mm-offer-card-badge--bogo mm-bogo-badge mm-bogo-badge--card">' +
      '<span class="mm-bogo-badge__pct">50% OFF</span>' +
      '<span class="mm-bogo-badge__text">Buy 1, Get 1 Free</span></div>';
  }

  function saleBadge(text, layout) {
    if (layout === 'grid') {
      return '<div class="mm-offer-card-badge">' + esc(text) + '</div>';
    }
    return '<span class="mmh-carousel-card__tag mmh-carousel-card__tag--sale">' +
      '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>' +
      esc(text) + '</span>';
  }

  function isOfferCurrent(offer) {
    if (!offer || offer.active === false || offer.enabled === false || offer.isActive === false) return false;
    var status = String(offer.status || '').trim().toLowerCase();
    if (['draft', 'inactive', 'disabled', 'expired', 'archived', 'deleted'].indexOf(status) >= 0) return false;
    var now = Date.now();
    var startsRaw = offer.startsAt || offer.startAt || offer.startDate || offer.starts_at;
    var endsRaw = offer.endsAt || offer.endAt || offer.endDate || offer.ends_at;
    var starts = startsRaw ? Date.parse(startsRaw) : NaN;
    var ends = endsRaw ? Date.parse(endsRaw) : NaN;
    if (!isNaN(starts) && starts > now) return false;
    if (!isNaN(ends) && ends <= now) return false;
    return true;
  }

  function flattenOffers(offers) {
    var out = [];
    var seen = new Set();

    offers.forEach(function (o) {
      if (!isOfferCurrent(o) || seen.has(o.id)) return;
      if (o.type === 'CART_TIER_GIFT') return;
      seen.add(o.id);

      if (o.type === 'DISCOUNTED_PRODUCT') {
        if (o._isGlobal || String(o.id || '').indexOf('global-') === 0) {
          out.push(o);
          return;
        }
        configItems(o.bundleItemsConfig).forEach(function (item) {
          if (!item || !item.handle) return;
          out.push({
            id: o.id + '-' + (item._uid || item.id || item.handle),
            type: o.type,
            title: o.title,
            titleAr: o.titleAr,
            slug: o.slug,
            images: o.images,
            endsAt: o.endsAt,
            customerQuantity: o.customerQuantity,
            triggerProducts: JSON.stringify([item.handle]),
            _manual: item
          });
        });
        return;
      }

      out.push(o);
    });

    return out.slice(0, 24);
  }

  function firstHandle(offer) {
    var triggers = jp(offer.triggerProducts);
    if (triggers[0]) return triggers[0];
    var items = configItems(offer.bundleItemsConfig);
    if (items[0] && items[0].handle) return items[0].handle;
    if (offer._prod && offer._prod.handle) return offer._prod.handle;
    return '';
  }

  function offerUrl(offer, handle) {
    if (window.MMOffers && window.MMOffers.offerNavUrl) {
      return window.MMOffers.offerNavUrl(offer, 'home', handle || firstHandle(offer));
    }
    var root = shopRoot();
    var h = handle || firstHandle(offer);
    if (offer && window.MMOffers && window.MMOffers.isCompareAtDeal && window.MMOffers.isCompareAtDeal(offer) && h) {
      var url = root + '/products/' + encodeURIComponent(h) + '?mm_ref=home';
      var manual = offer._manual || {};
      var vid = manual.selectedVariantId ? String(manual.selectedVariantId).split('/').pop() : '';
      if (!vid && window.MMOffers && window.MMOffers.variantIdFromOffer) {
        vid = window.MMOffers.variantIdFromOffer(offer);
      }
      if (vid) url += '&variant=' + encodeURIComponent(vid);
      return url;
    }
    var slug = offer.slug || '';
    if (!slug && offer.id && String(offer.id).indexOf('global-') !== 0) slug = offer.id;
    if (slug) return root + '/pages/offer?slug=' + slug + '&mm_ref=home';
    if (h) return root + '/products/' + encodeURIComponent(h) + '?mm_ref=home';
    return root + '/pages/bundles?mm_ref=home';
  }

  function cardTitle(offer, prod, el) {
    if (window.MMOffers && window.MMOffers.offerTitle) {
      return window.MMOffers.offerTitle(offer, prod, el);
    }
    if (isAr(el) && offer.titleAr) return offer.titleAr;
    if (offer.title) return offer.title;
    if (offer.name) return offer.name;
    var manual = offer._manual || {};
    if (offer.type === 'DISCOUNTED_PRODUCT') {
      if (isAr(el) && manual.titleAr) return manual.titleAr;
      if (manual.title) return manual.title;
    }
    if (prod && prod.title) return prod.title;
    return '';
  }

  function manualToMinor(val, el) {
    var n = parseFloat(val);
    if (!n || isNaN(n)) return 0;
    return Math.round(n * moneyDiv(el));
  }

  function enrichFromCache(offer, cache) {
    var handles = jp(offer.triggerProducts);
    var handle = handles[0] || '';
    if (!handle) {
      var items = configItems(offer.bundleItemsConfig);
      if (items[0] && items[0].handle) handle = items[0].handle;
    }
    offer._prod = handle ? cache[handle] : null;

    if (!offer._manual && (offer._isGlobal || String(offer.id || '').indexOf('global-') === 0)) {
      var cfgItems = configItems(offer.bundleItemsConfig);
      if (cfgItems[0]) offer._manual = cfgItems[0];
    }

    if ((offer._isGlobal || String(offer.id || '').indexOf('global-') === 0) && offer._prod) {
      var resolvedImg = window.MMOffers && window.MMOffers.compareAtDealImage
        ? window.MMOffers.compareAtDealImage(offer, offer._prod)
        : '';
      if (resolvedImg && offer._manual) offer._manual.image = resolvedImg;
    }

    if (offer.type === 'BUNDLE' || offer.type === 'BOGO') {
      var bundleItems = configItems(offer.bundleItemsConfig);
      offer._bundleProducts = bundleItems.map(function (item) {
        if (!item) return null;
        if (item.type === 'choice_group') {
          var opts = item.options || [];
          for (var i = 0; i < opts.length; i++) {
            if (opts[i] && opts[i].handle && cache[opts[i].handle]) return cache[opts[i].handle];
          }
          return null;
        }
        return item.handle ? cache[item.handle] : null;
      });
    }
    return offer;
  }

  function cardImage(offer, prod, cache) {
    if (window.MMOffers && window.MMOffers.isCompareAtDeal && window.MMOffers.isCompareAtDeal(offer)) {
      var compareImg = window.MMOffers.compareAtDealImage
        ? window.MMOffers.compareAtDealImage(offer, prod)
        : '';
      if (compareImg) return compareImg;
      return '';
    }

    var imgs = jp(offer.images);
    if (imgs[0]) return imgs[0];
    configItems(offer.bundleItemsConfig).forEach(function (item) {
      if (!imgs.length && item && item.image) imgs.push(item.image);
      if (!imgs.length && item && item.handle && cache[item.handle]) {
        var pi = cache[item.handle].featured_image;
        if (typeof pi === 'string') imgs.push(pi);
        else if (pi && pi.src) imgs.push(pi.src);
      }
    });
    if (!imgs.length && prod) {
      if (typeof prod.featured_image === 'string') imgs.push(prod.featured_image);
      else if (prod.featured_image && prod.featured_image.src) imgs.push(prod.featured_image.src);
    }
    return imgs[0] || '';
  }

  function typePill(offer, el) {
    var key = (offer.type || 'OFFER').toLowerCase();
    var label = window.MMOffers && window.MMOffers.typeLabel
      ? window.MMOffers.typeLabel(offer.type, el)
      : offer.type;
    return '<span class="mmh-offer-card__type mmh-offer-card__type--' + esc(key) + '">' + esc(label) + '</span>';
  }

  function volumeMaxPct(offer) {
    var tiers = jp(offer.volumeTiers);
    var best = 0;
    tiers.forEach(function (tier) {
      var d = parseFloat(tier.discount) || 0;
      if (d > best) best = d;
    });
    return Math.round(best);
  }

  function carouselCardTitle(offer, prod, el) {
    return cardTitle(offer, prod, el);
  }

  function offerSubtitle(offer, el) {
    if (offer._isGlobal || (String(offer.id || '').indexOf('global-') === 0 && offer.type === 'DISCOUNTED_PRODUCT')) {
      var vt = window.MMOffers && window.MMOffers.variantLabelFromOffer
        ? window.MMOffers.variantLabelFromOffer(offer, el)
        : '';
      if (vt && vt.indexOf('variants') === -1) return vt;
    }
    if (offer.type === 'BOGO') {
      return window.MMOffers && window.MMOffers.bogoLabel
        ? window.MMOffers.bogoLabel(offer, el)
        : t('اشتري 1 والثاني مجاناً', 'Buy 1 Get 1 Free', el);
    }
    if (offer.type === 'BUNDLE') {
      var n = configItems(offer.bundleItemsConfig).length;
      if (n > 0) return t(n + ' منتجات في الباقة', n + ' products in bundle', el);
    }
    if (offer.type === 'VOLUME') {
      var tiers = jp(offer.volumeTiers);
      if (tiers.length) {
        return t('اشتري أكثر واحصل على خصم أكبر', 'Buy more, save more', el);
      }
    }
    return '';
  }

  function cardPrices(offer, prod, el) {
    if (window.MMOffers && window.MMOffers.offerPrices) {
      return window.MMOffers.offerPrices(offer, prod || offer._prod, el);
    }
    var manual = offer._manual || {};
    var price = 0;
    var compare = 0;
    if (offer.type === 'DISCOUNTED_PRODUCT') {
      if (manual.manualPrice) price = manualToMinor(manual.manualPrice, el);
      else if (prod) price = prod.price || 0;
      if (manual.manualComparePrice) compare = manualToMinor(manual.manualComparePrice, el);
      else if (prod) compare = prod.compare_at_price || 0;
    } else if (prod) {
      price = prod.price || 0;
      compare = prod.compare_at_price || 0;
    }
    return { price: price, compare: compare };
  }

  function pricesBlock(prices, el, offer) {
    if (offer && offer.type === 'VOLUME') {
      if (window.MMOffers && window.MMOffers.estimateVolumePrices) {
        prices = window.MMOffers.estimateVolumePrices(offer, offer._prod || null, el);
      }
      var best = prices.maxPct != null ? prices.maxPct : volumeMaxPct(offer);
      if (best > 0 || prices.price > 0) {
        var volHtml = '<div class="mmh-offer-card__prices mmh-offer-card__prices--volume' + (best > 0 ? ' mmh-offer-card__prices--sale' : '') + '">';
        if (prices.price > 0) {
          volHtml += '<span class="mmh-offer-card__now">' + priceSpan(prices.price, el) + '</span>';
        }
        if (best > 0) {
          volHtml += '<span class="mmh-offer-card__save mmh-offer-card__save--upto">' +
            esc(t('يصل إلى ' + best + '%', 'Up to ' + best + '%', el)) + '</span>';
        }
        volHtml += '</div>';
        return volHtml;
      }
    }
    if (!prices.price && !prices.compare) return '';
    var savePct = 0;
    if (prices.compare > prices.price && prices.compare > 0) {
      savePct = Math.round((1 - prices.price / prices.compare) * 100);
    }
    var html = '<div class="mmh-offer-card__prices' + (savePct > 0 ? ' mmh-offer-card__prices--sale' : '') + '">';
    if (prices.price > 0) {
      html += '<span class="mmh-offer-card__now">' + priceSpan(prices.price, el) + '</span>';
    }
    if (prices.compare > prices.price && prices.compare > 0) {
      html += '<span class="mmh-offer-card__was">' + priceSpan(prices.compare, el) + '</span>';
    }
    if (savePct > 0) {
      html += '<span class="mmh-offer-card__save">' + esc(t('وفر ' + savePct + '%', 'Save ' + savePct + '%', el)) + '</span>';
    }
    html += '</div>';
    return html;
  }

  function mediaOverlayBlock(offer, el, settings) {
    var parts = [];
    if (offer.endsAt) {
      parts.push(
        '<span class="mmh-offer-card__ends">' +
          '<span class="mmh-offer-card__ends-icon" aria-hidden="true">⏱</span>' +
          '<span class="mmh-offer-card__ends-val" data-ends-at="' + esc(offer.endsAt) + '"></span>' +
        '</span>'
      );
    }
    if (offer.customerQuantity > 0) {
      var stock = window.MMOffers && window.MMOffers.stockLabel
        ? window.MMOffers.stockLabel(offer.customerQuantity, settings || {}, el)
        : t('متبقي ' + offer.customerQuantity, offer.customerQuantity + ' left', el);
      parts.push('<span class="mmh-offer-card__stock">' + esc(stock) + '</span>');
    }
    if (!parts.length) return '';
    return '<div class="mmh-offer-card__overlay">' + parts.join('') + '</div>';
  }

  function extrasBlock(offer, el, settings) {
    return mediaOverlayBlock(offer, el, settings);
  }

  function wireCardTimers(root, ctx) {
    if (!window.MMOffers || !window.MMOffers.startTimer) return;
    root.querySelectorAll('[data-ends-at]').forEach(function (node) {
      window.MMOffers.startTimer(node.getAttribute('data-ends-at'), node, ctx || root);
    });
  }

  function renderCarouselCard(offer, cache, el, settings) {
    var handle = firstHandle(offer);
    var prod = handle ? cache[handle] : (offer._prod || null);
    var img = cardImage(offer, prod, cache);
    var title = carouselCardTitle(offer, prod, el);
    if (title.length > 48) title = title.slice(0, 48) + '…';
    var url = offerUrl(offer, handle);
    var prices = cardPrices(offer, prod, el);
    var sub = offerSubtitle(offer, el);
    if (sub && (sub === title || title.indexOf(sub) >= 0 || sub.indexOf(title) >= 0)) sub = '';

    return '<article class="mmh-carousel-card mmh-offer-card mmh-offer-card--' + esc((offer.type || '').toLowerCase()) + '">' +
      '<a href="' + esc(url) + '" class="mmh-offer-card__link">' +
        '<div class="mmh-offer-card__media">' +
          (img
            ? responsiveImage(img, title, 'mmh-offer-card__img', '(min-width: 990px) 164px, 44vw')
            : '<span class="mmh-offer-card__img-ph" aria-hidden="true"></span>') +
          typePill(offer, el) +
          mediaOverlayBlock(offer, el, settings) +
        '</div>' +
        '<div class="mmh-offer-card__body">' +
          '<h3 class="mmh-offer-card__title">' + esc(title) + '</h3>' +
          (sub ? '<p class="mmh-offer-card__sub">' + esc(sub) + '</p>' : '') +
          pricesBlock(prices, el, offer) +
        '</div>' +
      '</a>' +
    '</article>';
  }

  function renderGridCard(offer, cache, el, settings) {
    var handle = firstHandle(offer);
    var prod = handle ? cache[handle] : (offer._prod || null);
    var img = cardImage(offer, prod, cache);
    var title = carouselCardTitle(offer, prod, el);
    if (title.length > 56) title = title.slice(0, 56) + '…';
    var url = offerUrl(offer, handle);
    var prices = cardPrices(offer, prod, el);
    var typeKey = (offer.type || '').toLowerCase();

    return '<a href="' + esc(url) + '" class="mm-offer-card mm-offer-card--' + esc(typeKey) + '">' +
      '<div class="mm-offer-card-image">' +
        (img ? responsiveImage(img, title, '', '(min-width: 990px) 240px, 44vw') : '<span class="mm-offer-card-image-ph"></span>') +
        typePill(offer, el).replace(/mmh-offer-card__type/g, 'mm-offer-card-ribbon') +
      '</div>' +
      '<div class="mm-offer-card-content">' +
        '<h3 class="mm-offer-card-name">' + esc(title) + '</h3>' +
        (offerSubtitle(offer, el) ? '<p class="mm-offer-card-sub">' + esc(offerSubtitle(offer, el)) + '</p>' : '') +
        extrasBlock(offer, el, settings).replace(/mmh-offer-card__/g, 'mm-offer-card-') +
        pricesBlock(prices, el, offer).replace(/mmh-offer-card__/g, 'mm-offer-card-') +
      '</div>' +
    '</a>';
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (window.MMOffers && window.MMOffers.fetchProductJs) {
      return window.MMOffers.fetchProductJs(handle);
    }
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
      return r.ok ? r.json() : null;
    } catch (e) {
      return null;
    }
  }

  async function loadOffers() {
    if (window.MMOffers && window.MMOffers.loadOffersList) {
      return window.MMOffers.loadOffersList();
    }
    try {
      var url = window.MMOffers && window.MMOffers.offersApiUrl ? window.MMOffers.offersApiUrl() : '/apps/mm-app/api/offers';
      var res = await fetch(url);
      return res.ok ? res.json() : { offers: [], settings: {} };
    } catch (e) {
      return { offers: [], settings: {} };
    }
  }

  async function quickOffers() {
    if (window.MMOffers && window.MMOffers.quickOffersList) {
      return window.MMOffers.quickOffersList(500);
    }
    return loadOffers();
  }

  function collectHandleMap(offers) {
    var handles = {};
    offers.forEach(function (o) {
      jp(o.triggerProducts).forEach(function (h) { if (h) handles[h] = 1; });
      jp(o.targetProducts).forEach(function (h) { if (h) handles[h] = 1; });
      if (o.type === 'BUNDLE' || o.type === 'BOGO' || o.type === 'VOLUME') {
        configItems(o.bundleItemsConfig).forEach(function (item) {
          if (!item) return;
          if (item.handle) handles[item.handle] = 1;
          if (item.type === 'choice_group') {
            (item.options || []).forEach(function (opt) { if (opt && opt.handle) handles[opt.handle] = 1; });
          }
        });
      }
    });
    return handles;
  }

  async function fillProductCache(handles) {
    var cache = {};
    var handleKeys = Object.keys(handles);
    for (var hi = 0; hi < handleKeys.length; hi += 6) {
      var batch = handleKeys.slice(hi, hi + 6);
      var batchRes = await Promise.all(batch.map(fetchProduct));
      batch.forEach(function (k, j) { if (batchRes[j]) cache[k] = batchRes[j]; });
    }
    return cache;
  }

  function paintMounts(mounts, offers, cache, settings) {
    mounts.forEach(function (el) {
      var layout = el.getAttribute('data-mm-offers-layout') || 'carousel';
      var section = el.closest('[data-mm-home-offers-section]');
      var emptyMsg = t('لا عروض حالياً', 'No offers right now', el);
      if (!offers.length) {
        if (section) section.hidden = true;
        el.innerHTML = '';
        el.classList.add('is-empty', 'is-ready');
        el.classList.remove('is-loading');
        return;
      }
      try {
        if (section) section.hidden = false;
        if (layout === 'grid') {
          el.innerHTML = offers.map(function (o) { return renderGridCard(o, cache, el, settings); }).join('');
        } else {
          el.innerHTML = offers.map(function (o) { return renderCarouselCard(o, cache, el, settings); }).join('');
        }
        wireCardTimers(el, el);
        el.classList.remove('is-loading');
        el.classList.add('is-ready');
        if (window.MMOffers && window.MMOffers.hydratePrices) {
          window.MMOffers.hydratePrices(el);
        }
        if (window.MMOffers && window.MMOffers.wireOfferNavigation) {
          window.MMOffers.wireOfferNavigation();
        }
        if (window.MMOffers && window.MMOffers.warmOfferUrls) {
          window.MMOffers.warmOfferUrls(
            offers.slice(0, 6).map(function (o) { return offerUrl(o, firstHandle(o)); }),
            { prerenderCount: 0 }
          );
        }
      } catch (renderErr) {
        console.error('[MM Home Offers] render', renderErr);
        if (section) section.hidden = true;
        el.innerHTML = '';
        el.classList.add('is-empty', 'is-ready');
        el.classList.remove('is-loading');
      }
    });
  }

  async function init() {
    var mounts = document.querySelectorAll('[data-mm-offers], [data-mm-offers-home]');
    if (!mounts.length) return;

    function finishEmpty(el, msg) {
      var section = el.closest('[data-mm-home-offers-section]');
      if (section) section.hidden = true;
      el.innerHTML = '';
      el.classList.add('is-empty', 'is-ready');
      el.classList.remove('is-loading');
    }

    function enrichInBackground(offers, settings, sequence) {
      var handles = collectHandleMap(offers);
      fillProductCache(handles).then(function (cache) {
        if (sequence !== renderSequence) return;
        var enriched = offers.map(function (o) { return enrichFromCache(o, cache); });
        paintMounts(mounts, enriched, cache, settings);
      }).catch(function (err) {
        console.warn('[MM Home Offers] cache enrich', err);
      });
    }

    async function show(apiRes) {
      var sequence = ++renderSequence;
      var settings = (apiRes && apiRes.settings) || {};
      var flat = flattenOffers((apiRes && apiRes.offers) || []);
      var expandFn = window.MMOffers && window.MMOffers.expandCompareAtOffers;
      var fetchFn = window.MMOffers && window.MMOffers.fetchProductJs
        ? window.MMOffers.fetchProductJs.bind(window.MMOffers)
        : fetchProduct;
      var offers = expandFn ? await expandFn(flat, fetchFn) : flat;
      if (sequence !== renderSequence) return;
      paintMounts(mounts, offers.map(function (o) { return enrichFromCache(o, {}); }), {}, settings);
      if (offers.length) enrichInBackground(offers, settings, sequence);
    }

    try {
      var cached = (window.MMOffers && window.MMOffers.offersSnapshot)
        ? window.MMOffers.offersSnapshot()
        : null;
      if (cached && cached._ok) {
        show(cached);
      } else if (window.__mmOffersBootstrap && Array.isArray(window.__mmOffersBootstrap.offers)) {
        show(window.__mmOffersBootstrap);
      } else if (window.__mmOffersPreload) {
        window.__mmOffersPreload.then(show).catch(function () {
          show({ offers: [], settings: {} });
        });
      } else {
        show({ offers: [], settings: {} });
      }

      if (!window.__mmHomeOffersRefreshWired) {
        window.__mmHomeOffersRefreshWired = true;
        window.addEventListener('mm:offers-updated', function (e) {
          if (!e.detail || !e.detail.data || !Array.isArray(e.detail.data.offers)) return;
          if (e.detail.handle) return;
          show(e.detail.data);
        });
      }

      loadOffers().then(show).catch(function (err) {
        console.error('[MM Home Offers]', err);
        mounts.forEach(function (el) {
          finishEmpty(el, t('لا عروض حالياً', 'No offers right now', el));
        });
      });
    } catch (err) {
      console.error('[MM Home Offers]', err);
      mounts.forEach(function (el) {
        finishEmpty(el, t('لا عروض حالياً', 'No offers right now', el));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('mm:currency-change', init);
})();
